import React from 'react'
import { getHexColor, TwoColorIconProps } from '../utils'

export const CheckBoxIconFilled: React.FC<TwoColorIconProps> = ({
  className,
  color1 = 'black',
  color2 = 'white',
  size = 16,
}) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2C3.79086 2 2 3.79086 2 6V18C2 20.2091 3.79086 22 6 22H18C20.2091 22 22 20.2091 22 18V6C22 3.79086 20.2091 2 18 2H6Z"
        fill={getHexColor(color1)}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8593 8.29289C17.2498 8.68342 17.2498 9.31658 16.8593 9.70711L11.3593 15.2071C11.1695 15.3969 10.9114 15.5024 10.6431 15.5C10.3747 15.4975 10.1186 15.3873 9.93233 15.1942L7.28019 12.444C6.89681 12.0465 6.90829 11.4134 7.30583 11.0301C7.70337 10.6467 8.33644 10.6582 8.71981 11.0557L10.6651 13.0728L15.445 8.29289C15.8356 7.90237 16.4687 7.90237 16.8593 8.29289Z"
        fill={getHexColor(color2)}
      />
    </svg>
  )
}
